import script from "./TressTextInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTextInput.vue?vue&type=script&lang=ts&setup=true"

import "./TressTextInput.vue?vue&type=style&index=0&id=45132d13&lang=scss"

const __exports__ = script;

export default __exports__